/* eslint-disable no-unused-vars */
/**
 * Handles Ad Unit mapping for each site
 * @access private
 */
function golden() {
  return [
    '201823409',
    'golden',
  ].join('/');
}

function hgtv({ env, page, network }) {
  return [
    network,
    page.site,
    page.categorydspname,
    page.sctndspname,
    page.subsection,
    page.subsection2,
  ]
	.filter(v => v && v.length)
	.join('/');
}

function disc({ env, page, network }) {
  return [
    network,
    page.site,
    page.section,
  ]
	.filter(v => v && v.length)
	.join('/');
}

function golfdigest({ env, page, slot }) {
  if (slot.useLegacyPath) {
    return [
      '21849421099',
      'golfdigest.cm',
      slot.position,
      page.categorydspname,
      page.contentType,
      slot.instance,
    ]
		.filter(v => v && v.length)
		.join('/');
  }

  return [
    '21849421099',
    'golfdigest',
    slot.position,
    page.ctx_page_channel,
    page.contentType,
    slot.instance,
  ]
	.filter(v => v && v.length)
	.join('/');
}

function other({ env, page, network }) {
  return [
    network,
    page.site,
    page.categorydspname,
    page.sctndspname,
  ]
	.filter(v => v && v.length)
	.join('/');
}

function fnk({ env, page, network }, configuration) {
  if (network === '201823409') return golden();
  return [
    network,
    'food',
    'fnk',
  ]
	.join('/');
}

function googleInterstitial({ env, page, network }, configuration) {
  return [
    network,
    page.site,
    'interstitial',
  ].join('/');
}

const hierarchyMaps = {
  hgtv,
  disc,
  golfdigest,
  'dtc-web': fnk,
  '*': other,
};

export default (meta = {}, configuration = {}) => {
  const { environmentOverride: metaOverride } = meta;
  const { environmentOverride: configurationOverride } = configuration;
  let network;

  const environmentOverride = configurationOverride || metaOverride;

  switch (environmentOverride) {
    case 'staging': {
      network = '201823409';
      break;
    }
    case 'golden': {
      return golden(meta, configuration);
    }
    default: {
      network = '8663477';
    }
  }

  if (meta.slot.isOutOfPage) return googleInterstitial({ ...meta, network }, configuration);

  const { site } = meta.page;

  const hierarchyMap = hierarchyMaps[site] || hierarchyMaps['*'];
  return hierarchyMap({ ...meta, network }, configuration);
};
